interface ProjectEditProps {
  projectId?: number;
  name?: string;
  description?: string;
  query?: string;
  color?: string;
  shared?: boolean;
}

export class ProjectEdit {
  public projectId?: number;
  public name?: string;
  public description?: string;
  public query?: string;
  public color?: string;
  public shared?: boolean;

  constructor({ projectId, name, description, query, color, shared }: ProjectEditProps) {
    this.projectId = projectId || null;
    this.name = name || null;
    this.description = description || null;
    this.query = query || null;
    this.color = color || null;
    this.shared = shared !== undefined ? shared : true;
  }
}
